<template>
    <div>
        <DxDataGrid
            height="450"
                id="gridContainer"
                :data-source="dataSource"
                :allow-column-reordering="true"
                :show-borders="true"
                key-expr="id"
                @saved="logEvent($event)"
        >
            <DxPaging :enabled="true"/>
            <DxEditing :allow-updating="true" :allow-adding="true" mode="row"/>
            <DxColumn data-field="text" caption="标签名" alignment="center" />
            <DxColumn data-field="total" caption="人数" alignment="center" :allowEditing="false"  />

        </DxDataGrid>
        <div align="center" >&nbsp;
            <DxButton  type="danger" :use-submit-behavior="true" @click="close" text="关闭"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "LabelTemplate",
        data() {
            return {
                dataSource: [],
            };
        },
        created() {
        },
        methods: {
            logEvent(e) {
                if(e.changes[0].type=="insert"){
                    this.add(e.changes[0].data)
                }else if(e.changes[0].type=="update"){
                    this.update(e.changes[0].data)
                }else {
                    this.del(e.changes[0].key)
                }

                // this.events.unshift(eventName);
            },

            add(e){
                if(e.text!=null){
                    this.$http.LabelAdd(e).then(res => {
                        if(res.status == "success"){
                          this.$message({type: 'success', message: res.msg, center: true});
                        }else {
                          this.$message({type: 'error', message: res.msg, center: true});
                        }

                    })
                }else {
                  this.$message({type: 'warning', message: '标签名不能为空', center: true});
                }
            },
            del(e){
                this.$http.LabelRemove({id:e}).then(res => {
                    if(res.status == "success"){
                      this.$message({type: 'success', message: res.msg, center: true});
                    }else {
                      this.$message({type: 'error', message: res.msg, center: true});
                    }

                })
            },

            update(e){
                if(e.text!=null){
                    this.$http.LabelEdit(e).then(res => {
                        if(res.status == "success"){
                          this.$message({type: 'success', message: res.msg, center: true});
                        }else {
                          this.$message({type: 'error', message: res.msg, center: true});
                        }

                    })
                }else {
                  this.$message({type: 'warning', message: '标签名不能为空', center: true});
                }
            },
            close(){
                this.$emit('close');
                this.$emit('refresh');
            },

        },
    }
</script>

<style scoped>

</style>
